import { render, staticRenderFns } from "./SelectTicketType.vue?vue&type=template&id=a1829450&scoped=true&"
import script from "./SelectTicketType.vue?vue&type=script&lang=js&"
export * from "./SelectTicketType.vue?vue&type=script&lang=js&"
import style0 from "./SelectTicketType.vue?vue&type=style&index=0&id=a1829450&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1829450",
  null
  
)

export default component.exports